import React, { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import BannerSingle from '../../../BannerSingle';
import Lgpd from '../../../Lgpd';
import TableSanfona from '../../../Tables/Sanfona';
import TabelaDinamica from '../../../Tables/TabelaDinamica';
import PlanoBRentabilidade from '../../../PageDescription/Planos/PlanoBRentabilidade';
// import RentabilidadeDownloadPdf from '../../../RentabilidadeDownloadPdf';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import TableSanfonaRentabilidate from '../../../Tables/SanfonaRentabilidade';
import Helper from "../../../Helper";

interface ComponentProps {
	page?: string;
}

interface ComponentState {
	isLoaded: boolean;
	result: any[];
}

class RentabilidadeBPage extends Component<ComponentProps, ComponentState> {

	private helper: Helper;

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			isLoaded: false,
			result: []
		};
		this.helper = new Helper(this);
	}

	componentDidMount() {
		this.helper.init('plano-b-rentabilidades');
	}

	componentDidUpdate(prevProps: ComponentProps, prevState: ComponentState) {
		if (this.state.result.length > 0 && prevState.result !== this.state.result) {
			document.title = this.state.result[0]?.Title;
		}
	}

	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<ErrorBoundary><BannerSingle image={"plano-b-rentabilidades"} page={"plano-b-rentabilidades"} items={this.state.result} /></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PlanoBRentabilidade page={'plano-b-rentabilidades'} items={this.state.result} /></ErrorBoundary>

					<div className="_the-content page-planos py-10">
						<div id='RMA' className='container'>
							<div className="row justify-content-center">
								<div className="col-md-10">
									<h3 > Perfis </h3>
									<p>
										Você conhece e acompanha a rentabilidade do seu plano? O participante deve consultar com frequência a rentabilidade, pois ela é o indicativo de rentabilização do plano, portanto, um determinante da sua saúde financeira.
										<br /> <br />
										O saldo da sua conta é corrigido mensalmente pela rentabilidade obtida, de acordo com o perfil escolhido, a comparação com o RMA é apenas um referencial indicativo.
										<br /> <br />
										* RMA – Rentabilidade Mínima Atuarial é a rentabilidade mínima que os ativos financeiros de um plano de benefícios deve ter para que possa cumprir com seus compromissos futuros. No caso do Plano B, a rentabilidade mínima atuarial esperada é de IPCA + 5,30% ao ano.
									</p>

									<br /> <br />

									<h4> Rentabilidade por perfil de investimento </h4><br />
									<ErrorBoundary><TabelaDinamica page={'PBRentabilidadePerfil'} /></ErrorBoundary>
									<br />
									<h4> Alocação por segmento de investimento </h4> <br />

									<ErrorBoundary><TabelaDinamica page={'PBRentabilidadeSegmento'} /></ErrorBoundary>
									{/* <ErrorBoundary><RentabilidadeDownloadPdf url={"/plano-b-rentabilidadesDowload"} /></ErrorBoundary> */}

									<br /> <br />

									<h3> Participantes Assistidos - Perfil - Mensal </h3>
									<br />

									{/* <p className="d-lg-none mb-0">
										Nota: Essa informação esta disponível apenas na versão web do site, dado a sua necessidade de detalhamento.
									</p> */}
									<br />

									<ErrorBoundary><TableSanfonaRentabilidate page={"PBRentabilidadeMensal"} /></ErrorBoundary>



								</div>
							</div>
						</div>
						<div id='MAT' className="bg-light py-10">
							<div className='container'>
								<div className='row justify-content-center'>
									<div className='col-md-10'>
										<h3 > Rentabilidade Mat Variável / Cotas </h3>
										<p>
											No caso do benefício Mat Variavel/Cotas, o saldo remanescente da conta de aposentadoria é corrigido mensalmente pela rentabilidade obtida, a comparação com o RMA é apenas um referencial indicativo. RMA – Rentabilidade Mínima Atuarial é a rentabilidade mínima que os ativos financeiros de um plano de benefícios deve ter para que possa cumprir com seus compromissos futuros. No caso do Plano B, a rentabilidade mínima atuarial esperada é de IPCA + 5,30% ao ano.
											<br /> <br />
											* RMA – Rentabilidade Mínima Atuarial é a rentabilidade mínima que os ativos financeiros de um plano de benefícios deve ter para que possa cumprir com seus compromissos futuros. No caso do Plano B, a rentabilidade mínima atuarial esperada é de IPCA + 5,30% ao ano.
										</p>

										<br /> <br />

										<h3> Rentabilidade por período </h3>
										<br />
										<ErrorBoundary><TabelaDinamica page={'PBRentabilidadeMATPeriodo'} /></ErrorBoundary>

										<br /> <br />

										<h3> Alocação por segmento de investimento </h3>

										<br />
										<div className="table double">
											<ErrorBoundary><TabelaDinamica page={'PBRentabilidadeMATSegmento'} /></ErrorBoundary>
										</div>
										<br /> <br />

										<h3> Participantes Assistidos - Saldo de Cotas - Mensal </h3>
										<br />

										{/* <p className="d-lg-none mb-0">
											Nota: Essa informação esta disponível apenas na versão web do site, dado a sua necessidade de detalhamento.
										</p> */}
										<br />

										<ErrorBoundary><TableSanfona page={"PBRentabilidadeMATMensal"} extraTextForYear="2022" extraText="* A partir de setembro de 2022, o participante do perfil cotas deverá considerar a rentabilidade do perfil de investimento escolhido." /></ErrorBoundary>

									</div>

								</div>
							</div>
						</div>
						<div id='VITALICIO' className="bg-white py-10">
							<div className='container'>
								<div className='row justify-content-center'>
									<div className='col-md-10'>
										<h3  > Rentabilidade Vitalício </h3>
										<br />
										<p>
											* RMA – Rentabilidade Mínima Atuarial é a rentabilidade mínima que os ativos financeiros de um plano de benefícios deve ter para que possa cumprir com seus compromissos futuros. No caso do Plano B, a rentabilidade mínima atuarial esperada é de IPCA + 5,30% ao ano.
										</p>
										<br /> <br />
										<h4> Rentabilidade por período </h4>
										<br />
										<ErrorBoundary><TabelaDinamica page={'PBRentabilidadeVITPeriodo'} /></ErrorBoundary>
										<br />
										<h3> Alocação por segmento de investimento </h3><br />
										<div className="table double">
											<ErrorBoundary><TabelaDinamica page={'PBRentabilidadeVITSegmento'} /></ErrorBoundary>
										</div>


										<h4>Participantes Assistidos - Vitalício - Mensal </h4>
										<br />
										<ErrorBoundary><TableSanfona page={"PBRentabilidadeVITMensal"} /></ErrorBoundary>
										{/* <p className="d-lg-none mb-0">
											Nota: Essa informação esta disponível apenas na versão web do site, dado a sua necessidade de detalhamento.
										</p> */}

									</div>
								</div>
							</div>

						</div>

					</div>

					{/* Content page */}

				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default RentabilidadeBPage;